import React, {useState,useRef}         from 'react';
import CloseBtn                         from 'assets/icons/Close.svg';
import { Modal, Form }                  from 'react-bootstrap';
import ReferralService                  from 'services/referral.service';
import AuthService                      from 'services/auth.service';
import Select                           from 'react-select';
import AsyncSelect                      from 'react-select/async';
import Spinner                          from 'react-bootstrap/Spinner';

export function ReferTo({specialties, getLogs}) {
  const defaultReferData = {
    patient_name: "",
    patient_email: "",
    patient_phone_number: "",
    note: "",
    specialty_id: "",
    referee_id: "",
    referral_letter_id: null
  }
  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
  const hiddenFileInput = useRef();
  const [showReferToModal, setShowReferToModal] = useState(false)
  const [referData, setReferData] = useState(defaultReferData);
  const [specialty, setSpecialty] = useState(null);
  const [errorFile, setErrorFile] = useState(''); 
  const [referralLetter, setReferralLetter] = useState(null);
  const [showReferralDone, setShowReferralDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleReferDoctor = () => {
    setSubmitting(false);
    setSpecialty(null);
    setErrorFile('');
    setReferData(defaultReferData);
    setReferralLetter(null);
    setShowReferralDone(false);
    setShowReferToModal(true);
  }

  const handleFieldChange = (e) => {
    setReferData(prevState => {
      return {...prevState, [e.target.name]: e.target.value};
    })
  }

  const onSpecialtyChange = (e) => {
    setSpecialty(e);
    setReferData(prevState => {
      return {...prevState, specialty_id: e.value};
    })
  }

  const onDoctorChange = (e) => {
    setReferData(prevState => {
      return {...prevState, referee_id: e.value};
    })
  }

  const doctorOptions = (keyword) => {
    if (keyword.length === 0 || !specialty.hasOwnProperty('value')) { return [] }
    const params = {
      keyword: keyword,
      page: 1,
      per_page: 12,
      specialty_id: specialty.value
    }
    return ReferralService.doctors(params).then(
      (data) => {
        return data.doctors.map(d => { return {value: d.id, label: d.name}});
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    ); 
  }


  const checkFileFormat = (file) => {
    setErrorFile('');

    if (!file) { return }

    if (!allowedTypes.includes(file.type)) {
      setErrorFile('File type can only be JPEG, JPG, PNG or PDF');
    } else if (file.size > 4000000) {
      setErrorFile('File size exceeds 4MB');
    } else {
      setUploading(true);
      ReferralService.uploadReferralLetter(file).then(
        (data) => {
          setReferralLetter(data);
          setReferData(prevState => {
            return {...prevState, referral_letter_id: data.id};
          })
          setUploading(false);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      ); 
    }
  };

  const ReferralLetter = () => {
    // add remove referral letter in the future
    if(referralLetter){
      const url = referralLetter.styles.origin.url;
      return  <a className="text-danger text-decoration-none" rel="noreferrer" target="_blank" href={url}>{url.substring(url.lastIndexOf('/')+1)}</a>;
    }else{
      return <span className="fweight-400 clickable text-danger" onClick={() => hiddenFileInput.current.click()}>Upload File</span>
    }
  }

  const submitReferral = () => {
    // check if everything not null 
    var error = false;
    const excludeKeys = ['referral_letter_id','note','patient_email']

    Object.keys(referData).forEach((key) => {
      if(!excludeKeys.includes(key) && (referData[key] === null || referData[key] === '' || referData[key] === 0)){
        error = true;
        return;
      }
    })

    if(error){
      alert("Please complete the referral form before submitting.");
      return;
    }

    // validate phone number
    const check_number = referData.patient_phone_number.replace(/([^+0-9]+)/gi, '');
    if((check_number.length < referData.patient_phone_number.length) || (referData.patient_phone_number.length > 12 || referData.patient_phone_number.length < 8)){
      // if true = wrong, false = regex pattern correct
      alert("Invalid Phone Number");
      return;
    }

    setSubmitting(true);
    ReferralService.submitReferral(referData).then(
      (data) => {
        getLogs(1);
        setSubmitting(false);
        setShowReferralDone(true);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    ); 
  }

  const spinnerDiv = () => {
    return <Spinner animation="border" className="spinner"/>;
  }

  const referralForm = () => {
    return (
      <>
        <div className="d-flex flex-column">
          <div className="row">
            <Form.Group className="mb-3 px-2 col-12 col-md-6">
              <Form.Label>Patient Name</Form.Label>
              <Form.Control value={referData.patient_name} name="patient_name" onChange={(e) => handleFieldChange(e)}/>
            </Form.Group>
            <Form.Group className="mb-3 px-2 col-12 col-md-6">
              <Form.Label>Patient Phone</Form.Label>
              <Form.Control value={referData.patient_phone_number} name="patient_phone_number" onChange={(e) => handleFieldChange(e)} maxLength={12} minLength={8}/>
              <small className="text-secondary">E.g. +60123456789 (no space/dash)</small>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 px-2 col-12 col-md-6">
              <Form.Label>Patient Email (Optional)</Form.Label>
              <Form.Control type="email" value={referData.patient_email} name="patient_email" onChange={(e) => handleFieldChange(e)}/>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 px-2 col-12 col-md-6">
              <Form.Label>Specialty</Form.Label>
              <Select placeholder="" name="specialties" options={specialties} onChange={(e) => onSpecialtyChange(e)}/>
            </Form.Group>

            <Form.Group className="mb-3 px-2 col-12 col-md-6">
              <Form.Label>Doctor</Form.Label>
              <AsyncSelect placeholder="" cacheOptions defaultOptions loadOptions={ doctorOptions } isDisabled={specialty === null} onChange={(e) => onDoctorChange(e) } />
            </Form.Group>
          </div>
          <div className="row mt-3">
            <Form.Group className="mb-3 px-2 col-12">
              <Form.Label>Note</Form.Label>
              <Form.Control as="textarea" value={referData.note} name="note" onChange={(e) => handleFieldChange(e)} maxLength={150}/>
            </Form.Group>
          </div>
          <div className="d-flex mt-3 flex-column">
            <div className="row">
              <div className="col-4">
                <div>Upload File(Optional)</div>
                <small>File can be in either JPEG, JPG, PNG or PDF formats.<br/>Size limit is 4MB.</small>
              </div>
              <div className="font-size-6 flex-grow-1">
                <input type="file" onChange={(e) => checkFileFormat(e.target.files[0]) } value="" className="d-none" ref={ hiddenFileInput } accept={allowedTypes.join(',')} />
                {uploading ? spinnerDiv() : <ReferralLetter /> }
              </div>
            </div>
            {errorFile && <small className="text-danger">{errorFile}</small>}
          </div>
        </div>
        <div className="mt-3 text-right">
          {submitting ? spinnerDiv() : <button className="btn btn-danger" onClick={() => submitReferral()}>Save</button>}
        </div>
      </>
    );
  }

  const ReferralDone = () => {
    return (
      <div className="text-center">
        Thanks for the referral! An email notification will be sent to the referred doctor and the patient.
      </div>
    );
  }
  
  const ReferToModal = () => {
    return (
      <Modal size="lg" show={showReferToModal} onHide={() => setShowReferToModal(false)}>
        <Modal.Header>
          {!showReferralDone && <Modal.Title>Referral Details</Modal.Title>}
          <button type="button" className="close" onClick={() => setShowReferToModal(false)}>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>
        <Modal.Body>
          {showReferralDone ? <ReferralDone /> : referralForm() }
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-end">
        <button className="btn btn-danger refer-doc-btn" onClick={() => handleReferDoctor()}>Refer Doctor</button>
      </div>
      {ReferToModal()}
    </>
  )
}

export default ReferTo;